import React from 'react'

import { MenuItem } from '@mui/material'
import { Icon } from 'components'
import { theme } from 'styles/theme/hav-theme'

import { ButtonStyled, LinkStyled, MenuStyled, TextButton, TextLink } from './styles'

type OptionDownloadLink = {
  label: string
  url: string
}

export interface DownloadLinkProps {
  href?: string
  content?: string
  target?: React.HTMLAttributeAnchorTarget
  options?: OptionDownloadLink[]
  disabled?: boolean
}

export const DownloadLink: React.FC<DownloadLinkProps> = ({
  href = '#',
  content = '',
  target = '_blank',
  options = [] as OptionDownloadLink[],
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const containerRef = React.useRef<HTMLDivElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const selectModel = (url: string) => {
    window.open(url)
    setAnchorEl(null)
  }

  return (
    <>
      {options.length > 0 ? (
        <LinkStyled ref={containerRef}>
          <ButtonStyled
            aria-controls={open ? 'basic-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            disabled={disabled}
            endIcon={<Icon color={theme.colors.primary.main} icon="chevron-down" size="15" />}
            id="basic-button"
            onClick={handleClick}
          >
            <TextButton disabled={disabled}>{content}</TextButton>
          </ButtonStyled>
          <MenuStyled
            anchorEl={anchorEl}
            id="basic-menu"
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
            minwidth={containerRef.current?.clientWidth}
            onClose={() => setAnchorEl(null)}
            open={open}
          >
            {options.map((option) => (
              <MenuItem key={option.label} onClick={() => selectModel(option.url)}>
                {option.label}
              </MenuItem>
            ))}
          </MenuStyled>
        </LinkStyled>
      ) : (
        <LinkStyled>
          <Icon
            color={theme.colors.primary.main}
            data-testid="download-icon"
            icon="download"
            size="15"
          />
          <TextLink data-testid="download-link" href={href} target={target}>
            {content}
          </TextLink>
        </LinkStyled>
      )}
    </>
  )
}
